import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { dataIntervalExport } from '../params';
import { postApi } from '../../lib/fetcher';

const merchant = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      totalMerchants: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      merchantDocument: [],
      countData: 0,
      countSuccess: 0,
      countFailed: 0,
      uploadProgress: 0,
      onUpload: false,
      insertProgress: 0,
      onInsert: false,
      insertName: '',
      importId: null,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalImport: null,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      totalPage: 0,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setDetailMerchant(state, { payload }) {
      state.merchant = payload;
    },
    setMerchantVariable(state, { variable, payload }) {
      state.merchant[variable] = payload;
    },

    setMerchantDocument(state, document) {
      state.merchantDocument.push(document);
    },
    setUploadProgress(state, uploadProgress) {
      state.uploadProgress = uploadProgress;
    },
    setOnUpload(state, onUpload) {
      state.onUpload = onUpload;
    },
    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },
    setInsertName(state, insertName) {
      state.insertName = insertName;
    },
    setOnInsert(state, onInsert) {
      state.onInsert = onInsert;
    },
    setIntervalImport(state, payload) {
      state.intervalImport = payload;
    },
    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },
    setImportData(state, payload) {
      state.importId = payload.import_id;
      state.countData = payload.count_data;
    },
    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },
    setDownloadFailedURL(state, payload) {
      state.downloadFailedURL = payload;
    },
    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
    clearLastResult(state) {
      state.countData = 0;
      state.countSuccess = 0;
      state.countFailed = 0;
      state.countDone = 0;
      state.countSame = 0;
      state.uploadProgress = 0;
      state.onUpload = false;
      state.insertProgress = 0;
      state.onInsert = false;
      state.insertName = '';
      state.intervalImport = null;
      state.importId = null;
      state.downloadFailedURL = '';
    },
  },

  actions: {
    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, merchantId, action }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'merchant':
            return 'merchant/merchant/index';
          case 'outlet':
            return 'outlet/outlet/index';
          default:
            return 'merchant/merchant/index';
        }
      };
      const merchantIdVal = merchantId == null ? '' : merchantId;

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        merchant_id: merchantIdVal.toString(),
        version:
          merchantIdVal == ''
            ? btoa(
              CryptoJS.SHA256(
                itemsPerPage.toString() +
                    page.toString() +
                    date +
                    atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            )
            : btoa(
              CryptoJS.SHA256(
                merchantIdVal.toString() +
                    sort_by.toString() +
                    itemsPerPage.toString() +
                    page.toString() +
                    date +
                    atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
      });

      const urlApi = `/index.php?r=api/v1/${controller(action)}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async updateMerchant(ctx, { date, merchant_id, daerah, tempUniqueData }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        merchant_id,
        merchant_name: ctx.state.merchant.merchant_name,
        ktp_no:
          tempUniqueData.ktp_no == ctx.state.merchant.ktp_no
            ? ''
            : ctx.state.merchant.ktp_no,
        mobile_phone: ctx.state.merchant.mobile_phone,
        company_name: ctx.state.merchant.company_name,
        owner_name: ctx.state.merchant.owner_name,
        merchant_criteria: ctx.state.merchant.merchant_criteria,
        npwp_no:
          tempUniqueData.npwp_no == ctx.state.merchant.npwp_no
            ? ''
            : ctx.state.merchant.npwp_no,
        address: ctx.state.merchant.address,
        email:
          tempUniqueData.email == ctx.state.merchant.email
            ? ''
            : ctx.state.merchant.email,
        phone: ctx.state.merchant.phone,
        phone_area_code: ctx.state.merchant.phone_area_code,
        province_name: daerah.province_name,
        city_name: daerah.city_name,
        sub_district_name: daerah.sub_district_name,
        urban_name: daerah.urban_name,
        postal_code: daerah.postal_code,
        province_id: '',
        city_id: '',
        sub_district_id: '',
        urban_id: '',
        no_rekening:
          tempUniqueData.account_number == ctx.state.merchant.account_number
            ? ''
            : ctx.state.merchant.account_number,
        approver_1: ctx.state.merchant.approver_1_id,
        approver_2: ctx.state.merchant.approver_2_id,
        mcc: ctx.state.merchant.mcc,
        mdr_on_us: ctx.state.merchant.mdr_on_us,
        mdr_off_us: ctx.state.merchant.mdr_off_us,
        version: btoa(
          CryptoJS.SHA256(
            merchant_id.toString() +
              ctx.state.merchant.merchant_name.toString() +
              ctx.state.merchant.owner_name.toString() +
              ctx.state.merchant.merchant_criteria.toString() +
              daerah.postal_code.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/merchant/merchant/update`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },

    async viewMerchant(ctx, { date, id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/merchant/merchant/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setDetailMerchant', {
          payload: responseData.data,
        });
      }
    },

    async viewDocument(ctx, { date, id, doc_type: docType, type, download }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        account_id: id,
        type,
        doc_type: docType,
        download,
        version: btoa(
          CryptoJS.SHA256(
            type.toString() +
              docType.toString() +
              id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/document/document/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.data?.base64_image) {
        return responseData.data.base64_image;
      }

      return null;
    },

    async getQRList(
      ctx,
      { date, id, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        id,
        page,
        limit: itemsPerPage,
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/merchant/merchant/qr-list`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        return responseData.data;
      }
      return null;
    },

    async downloadTemplate(ctx, { action }) {
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'add':
            return 'bulk-upload-merchant';
          case 'add-outlet':
            return 'bulk-add-outlet';
          case 'update':
            return 'bulk-update-merchant';
          case 'update-outlet':
            return 'bulk-update-merchant';
          default:
            return 'bulk-upload-merchant';
        }
      };

      const urlApi = `/index.php?r=api/v1/onboarding/${controller(
        action
      )}/download`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        return responseData.data;
      }
      return null;
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, view, IDMerchant }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const controller = (ctrl) => {
        switch (ctrl) {
          case 'merchant':
            return 'export-merchant-list';
          case 'merchant-outlet':
            return 'export-outlet-list';
          default:
            return 'export-merchant-list';
        }
      };

      const version =
        view == 'merchant'
          ? btoa(
            CryptoJS.SHA256(
              page.toString() +
                  itemsPerPage.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
            ).toString()
          )
          : btoa(
            CryptoJS.SHA256(
              itemsPerPage.toString() +
                  page.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
            ).toString()
          );

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        merchant_id: IDMerchant.toString(),
        version,
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/${controller(view)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        if (responseData.data.message != null) {
          showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: controller(view),
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },
  },
};

export default merchant;
